export class Organisation {
    kvk!: string;
    dashboardInfo!: any;
    users!: any[];
    organisation!: any;
    Organisations!: any[];
    signingBundleTypes!: any[];
    signingBundle!: any;
    signingBundles!: any[];
    credits!: any;
    WorkGroup!: any;
    WorkGroups!: any[];
    WorkgroupMember!: any;
    WorkgroupMembers!: any[];
}
